<template lang="pug">
div
	.card.text-left
		.card-header.bg-dark.text-white
			span.fa.fa-search.mr-2
			|Buscador de tareas
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
					.row
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Anunciante
								input.form-control.form-control-sm(type="text" @keypress.enter="buscar()" v-model="form.anunciante" placeholder="Nombre del anunciante")
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Cliente (a quien se factura)
								input.form-control.form-control-sm(type="text" @keypress.enter="buscar()" v-model="form.cliente" placeholder="Nombre del cliente")
					.row
						.col
							.form-group
								label Agente
								input.form-control.form-control-sm(type="text" @keypress.enter="buscar()" v-model="form.agente" placeholder="Nombre del agente")
						.col
							.form-group
								label Nº XFrame
								input.form-control.form-control-sm(type="text" @keypress.enter="buscar()" v-model="form.xframe" placeholder="Nombre del agente")
				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
					.row
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Tipo
								select.form-control.form-control-sm(name="" v-model="form.tipo" @change="buscar()")
									option(:value="null")|Todos
									option(value="cuna")|Cuña
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Procedencia
								select.form-control.form-control-sm(name="" v-model="form.procedencia" @change="buscar()")
									option(:value="null")|Todas
									option(value="directa")|Subida directa
									option(value="produccion")|Producción propia
					.row
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Estado
								br
								.btn-group
									button.btn.btn-sm(:class="(form.estado === 'todas') ? 'btn-danger' : 'btn-default'" @click="setEstado('todas')")|Todas
									button.btn.btn-sm(:class="(form.estado === 'pendientes') ? 'btn-danger' : 'btn-default'" @click="setEstado('pendientes')")|Pendientes
									button.btn.btn-sm(:class="(form.estado === 'finalizadas') ? 'btn-danger' : 'btn-default'" @click="setEstado('finalizadas')")|Finalizadas
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Destino
								br
								.btn-group
									button.btn.btn-sm(:class="(form.externa === null) ? 'btn-primary' : 'btn-default'" @click="setDestino(null)")
										|Todas
									button.btn.btn-sm(:class="(form.externa === 0) ? 'btn-primary' : 'btn-default'" @click="setDestino(0)")
										|Propias
									button.btn.btn-sm(:class="(form.externa === 1) ? 'btn-primary' : 'btn-default'" @click="setDestino(1)")
										|Externas
				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
					.row
						.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-6
							.form-group
								label Desde
								datepicker(
									v-model="form.fechaIni"
									:bootstrap-styling="true"
									:language="$dateLang"
									:monday-first="true"
									placeholder="DD-MM-YYYY"
								)
						.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-6
							.form-group
								label Hasta
								datepicker(
									v-model="form.fechaFin"
									:bootstrap-styling="true"
									:language="$dateLang"
									:monday-first="true"
									placeholder="DD-MM-YYYY"
								)
					.form-group
						label Locutor(es)
						input-query(:realtime="true" :input-class="'form-control form-control-sm'" placeholder="Busca y selecciona los locutores" :url="'produccion/php/api/buscaLocutores.php'" @selected="seleccionaLocutor($event)")
					.card.mb-1.mr-1.p-0(style="position:relative;display:inline-block;" v-for="locutor in form.locutores" :key="locutor.ID_locutor")
						.card-body.p-1.bg-light.text-left
							img.rounded-circle.mr-2(:src="locutor.avatar" alt="" style="width:30px;display:inline-block;vertical-align:middle;")
							b {{locutor.nombre}} {{locutor.apellidos}}
							button.btn.btn-sm.btn-danger.ml-2(@click="quitaLocutor(locutor)")
								span.fa.fa-trash
		.card-footer
			button.btn.btn-sm.btn-primary(@click="buscar()")
				span.fa.fa-search.mr-1
				|Buscar
			button.btn.btn-sm.btn-danger(:disabled="descargando" @click="descargar()")
				span.fa.fa-download.mr-1
				|Descargar audios
	.card.mt-2.text-left
		.card-header.bg-dark.text-white
			|{{resultados.length}} Resultados
			span(v-if="limite") (limitado a {{limite}})
		table.table.table-striped.table-condensed(v-if="resultados.length > 0")
			thead
				tr
					th Agente
					th Anunciante y cliente
					th Tipo
					th Título
					th Fecha de creación
					th Estado
					th Ficheros
					th
			tbody
				tr(v-for="tarea in resultados" :key="tarea.ID_tarea" :class="(tarea.fase === 'cancelada') ? 'bg-danger text-white' : ''")
					td {{ tarea.agenteNombre }}
					td
						|{{ tarea.anuncianteNombre }}
						br
						span.text-muted
							|{{ tarea.clienteNombre }}
					td
						span(v-if="tarea.externa")
							span.fa.fa-gift(title="Externa")
						span(v-if="!tarea.externa")
							span.fa.fa-flag(title="Propia")
					td
						|{{ tarea.tareaTitulo }}
					td
						|{{ new Date(tarea.tareaFechaCreacion * 1000).toLocaleDateString() }}
					td
						span(v-if="tarea.fase === 'cancelada'")|Cancelada
						span(v-else-if="tarea.tareaFechaFin === null")|Pendiente
						span(v-else-if="tarea.tareaFechaFin !== null")|Finalizada
					td
						|{{ tarea.ficheros }} ficheros
					td
						button.btn.btn-sm.btn-warning(v-if="tarea.tareaFechaFin" @click="auditando = tarea.ID_tarea")
							span.fa.fa-calendar
						button.btn.btn-sm.btn-info(@click="abrir(tarea)")
							span.fa.fa-eye
						</button>
		.text-center.text-muted(v-if="resultados.length === 0")
			span.fa.fa-list.m-3(style="font-size:4em;")
			h3 No hay resultados
	auditor(v-if="auditando" :idtarea="auditando" @cerrar="auditando = null")
</template>

<style>
.form-group .vdp-datepicker .input-group > input {
  background-color: white !important;
}
</style>

<script>

import Auditor from './auditor.vue'
import API from '../../services/api'

export default {
	name: 'buscador',
	components: {
		'auditor': Auditor
	},
	data: function () {
		return {
			descargando: false,
			form: {
				anunciante: '',
				cliente: '',
				agente: '',
				tipo: null,
				estado: 'todas',
				locutores: [],
				externa: null,
				fechaIni: null,
				fechaFin: null,
				procedencia: null,
				xframe: ''
			},
			resultados: [],
			auditando: null,
			limite: 0
		}
	},

	created () {
		this.form.fechaIni = new Date()
		this.form.fechaIni.setMonth(this.form.fechaIni.getMonth() - 2)
		this.buscar()
	},

	methods: {

		buscar () {
			API.buscaTareas(this.form)
				.then(res => {
					this.resultados = res.data.resultados
					this.limite = res.data.limite
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: (e.response.data.error) ? e.response.data.error : 'Error desconocido'
					})
				})
		},

		descargar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Descargar audios',
				mensaje: 'Este proceso puede demorarse, por lo que tendrás que tener paciencia. ¿Quieres continuar?',
				callback: (accept) => {
					if (accept) {
						this.descargando = true
						const filtro = this.form
						const form = JSON.parse(JSON.stringify(filtro))
						if (filtro.fechaIni) {
							filtro.fechaIni.setHours(0)
							filtro.fechaIni.setMinutes(0)
							filtro.fechaIni.setSeconds(0)
						}

						if (filtro.fechaFin) {
							filtro.fechaFin.setHours(23)
							filtro.fechaFin.setMinutes(59)
							filtro.fechaFin.setSeconds(59)
						}
						form.fechaIni = (filtro.fechaIni) ? Math.floor(filtro.fechaIni.getTime() / 1000) : null
						form.fechaFin = (filtro.fechaFin) ? Math.floor(filtro.fechaFin.getTime() / 1000) : null
						this.download('produccion/php/api/descargarAudios.php', form, 'audios.zip', () => {
							this.descargando = false
						})
					}
				}
			})
		},

		seleccionaLocutor (datos) {
			for (let i = 0; i < this.form.locutores.length; i++) {
				if (this.form.locutores[i].ID_locutor === datos.datos.ID_locutor) {
					return
				}
			}

			this.form.locutores.push(datos.datos)

			this.buscar()
		},

		quitaLocutor (loc) {
			for (let i = 0; i < this.form.locutores.length; i++) {
				if (this.form.locutores[i].ID_locutor === loc.ID_locutor) {
					this.form.locutores.splice(i, 1)
					this.buscar()
					return
				}
			}
		},
		setEstado (est) {
			this.form.estado = est
			this.buscar()
		},
		setDestino (dest) {
			this.form.externa = dest
			this.buscar()
		},
		abrir (tarea) {
			const datos = {
				ID_tarea: tarea.ID_tarea,
				nombre: tarea.tareaTitulo
			}
			this.$emit('abrir', datos)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/buscador/buscador.vue